/** Optional getToolUse foldout overrides for UI harnesses, keyed by tool_use id. */
export const toolFoldoutMocks = new Map<string, any>();

export function clearToolFoldoutMocks() {
    toolFoldoutMocks.clear();
}

export function setToolFoldoutMock(toolId: string, content: any) {
    toolFoldoutMocks.set(toolId, content);
}
